// Inspector inputs ke liye shared class (Bootstrap)
export const inputCls = "form-control form-control-sm";

// label + control wrapper
export function Field({ label, children }) {
  return (
    <div className="mb-3">
      <label className="form-label small text-secondary mb-1">{label}</label>
      {children}
    </div>
  );
}
